


















































































































































































































































































import baseUrl from '@/utils/envConfig'
import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'

import {
  resetObjValue2NoneString,
  downFile
} from '@/utils/tool'
import { getCookie } from '@/utils/cookies'
import { getActivityList,
  saveVipActivity,
  activityOn,
  activityOff,
  deleteActivity } from '@/api/trade/trade'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import singlePhoto from '@/components/base/single-photo.vue'

const buttons: any = [
  {
    text: '下架',
    id: 0
  },
  {
    text: '上架',
    id: 1
  },
  {
    text: '编辑',
    id: 2
  },
  {
    text: '删除',
    id: 3
  }
]

const statusMap: any = new Map([[1, '上架'], [2, '下架'], [3, '删除']])

@Component({
  components: { singlePhoto },
  name: 'TradeVip'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    page: 1,
    pageCount: 20,
    status: '1'
  }
  private formParams: any = {
    id: 0,
    name: '',
    begin_time: '',
    end_time: '',
    pics: '',
    status: 1
  }
  private pics: any = {
    cn: '',
    en: ''
  }
  // component data
  validityTime = ''
  dateArrayActivity: any[] = []
  buttons: any[] = buttons
  dateArrayExpire = ['', '']
  dateArrayPay = ['', '']
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount: number = 0
  tableHeight: number = 500
  formVisible = false
  duration: string = ''
  statusMap = statusMap
  // lifecycle
  async created() {
    const { query } = this.$route
    if (query.status) {
      this.params.status = query.status as string
    }
    this.getTableData()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  // methods
  async getTableData() {
    this.tableLoading = true
    let res = await getActivityList(this.params)
    // console.log(res)
    this.tableData = res.data.dataList
    this.totalCount = res.data.pageInfo.totalCount
    this.tableLoading = false
  }
  handleDateChange(date: string[]) {
    this.formParams.begin_time = date && date[0]
    this.formParams.end_time = date && date[1]
  }
  rowClassName(scope: any) {
    // 把每一行的索引放进row.id
    scope.row.number = scope.rowIndex + 1
  }
  setParams(params: any) {
    let arr = []
    let ignoreList: string[] = ['page', 'pageCount']
    for (let key in params) {
      if (!ignoreList.includes(key)) {
        arr.push(key + '=' + params[key])
      }
    }
    return arr.join('&')
  }

  handleChangeStatus(status: string) {
    this['$router'].push({
      query: {
        status
      }
    })
    this.getTableData()
  }

  setTableHeight() {
    this.tableHeight = document.body.clientHeight - 200
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayPay = ['', '']
    this.dateArrayExpire = ['', '']
    this.params.page = 1
    this.getTableData()
  }
  handleAdd() {
    this.formParams = {
      id: 0,
      name: '',
      begin_time: '',
      end_time: '',
      pics: '',
      status: 1
    }
    this.dateArrayActivity = []
    this.pics = {
      cn: '',
      en: ''
    }
    this.formVisible = true
  }
  handleSelectionChange(list: any[]) {
    // console.log(list)
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    // this.setAccount(this.selectIds)
  }
  handleManage(item: any, id: number) {
    let manage: any[] = [this.handleOff, this.handleOn, this.handleEdit, this.handleDelete]
    manage[id](item)
  }
  handleEdit(item: any) {
    console.log(item)
    this.formParams.id = item.id
    this.formParams.name = item.name
    this.formParams.begin_time = item.begin_time
    this.formParams.end_time = item.end_time
    this.dateArrayActivity = [item.begin_time, item.end_time]
    this.formParams.status = item.status
    let pics = JSON.parse(item.pics)
    this.pics.cn = pics.cn
    this.pics.en = pics.en
    this.formVisible = true
  }
  handleDelete(item: any) {
    console.log(item.id)
    this.$confirm('是否确认要删除?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        deleteActivity({ ids: item.id }).then(res => {
          console.log(res)
          this.$message.success('操作成功')
          this.params.status = '3'
          this.handleChangeStatus('3')
        }).catch(() => {})
      })
      .catch(() => {})
  }
  handleOn(item: any) {
    this.$confirm('是否确认要上架?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        activityOn({ ids: item.id }).then(res => {
          console.log(res)
          this.$message.success('操作成功')
          this.params.status = '1'
          this.handleChangeStatus('1')
        }).catch(() => {})
      })
      .catch(() => {})
  }
  handleOff(item: any) {
    this.$confirm('是否确认要下架?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        activityOff({ ids: item.id }).then(res => {
          console.log(res)
          this.$message.success('操作成功')
          this.params.status = '2'
          this.handleChangeStatus('2')
        }).catch(() => {})
      })
      .catch(() => {})
  }
  handleOffAll() {
    let ids = this.selectIds
    activityOn({ ids }).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.getTableData()
    }).catch(() => {})
  }
  handleOnAll() {
    let ids = this.selectIds
    activityOff({ ids }).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.getTableData()
    }).catch(() => {})
  }
  handleDeleteAll() {
    let ids = this.selectIds
    deleteActivity({ ids }).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.getTableData()
    }).catch(() => {})
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelForm()
  }
  cancelForm() {
    (this.$refs['formParams'] as Form).resetFields()
    this.formVisible = false
  }
  checkParams() {
    let p = this.formParams
    // let { cn, en } = this.pics
    if (p.name.trim().length <= 0) return '请输入活动名称'
    if (!p.begin_time) return '请选择优惠活动开始时间'
    if (!p.end_time) return '请选择优惠活动结束时间'
    // if (!cn) return '请上传活动图片(中文)'
    // if (!en) return '请上传活动图片(英文)'
    return ''
  }
  confirmForm() {
    this.formParams.pics = JSON.stringify(this.pics)
    let result: string = this.checkParams()
    if (result.length) {
      return this.$message.warning(result)
    }
    console.log(this.pics)
    console.log(this.formParams)
    saveVipActivity(this.formParams).then(res => {
      console.log(res)
      this.$message.success('操作成功')
      this.formVisible = false
      this.getTableData()
    }).catch(err => {
      console.log(err)
    })
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
